import CustomLink from 'designsystem/CustomLink'
import { Card } from '../designsystem/Card'
import PersonInfo from './PersonInfo'
import Markdown from 'markdown-to-jsx'

interface TestimonialCardProps extends React.HTMLAttributes<HTMLDivElement> {
  // @todo unused?
  twitter?: string | null
  name: string
  title: string
  quote: string
  profileImage: string
  className?: string
  linkHref?: string
  linkText?: string
}

const TestimonialCard = ({
  twitter,
  name,
  title,
  quote,
  profileImage,
  className,
  linkHref,
  linkText,
  ...props
}: TestimonialCardProps): JSX.Element => (
  <Card
    noPadding
    noMaxWidth
    className={`h-full flex flex-col justify-between card-padding ${
      className || ''
    }`}
    {...props}
  >
    <Markdown
      className='quotation-marks'
      options={{ forceWrapper: true, wrapper: 'blockquote' }}
    >
      {quote}
    </Markdown>
    <PersonInfo
      className='spacer-sm'
      name={name}
      title={title}
      image={profileImage}
    />
    {linkHref && linkText && (
      <CustomLink
        href={linkHref}
        text={linkText}
        className='spacer-sm self-end'
      />
    )}
  </Card>
)

export default TestimonialCard
